/**
 *
 * Die Prüfziffernberechnung erfolgt im „Lok- and Waggon-Kennzeichnungsverfahren“ nach folgendem Schema:
 * a) Quersumme aller Ziffern in ungerader Position
 * b) Quersumme aller Ziffern auf gerader Position multipliziert mit 2
 * c) Summe von a) und b)
 * d) Differenz von c) zum nächsten Vielfachen von 10 (ergibt sich hier 10, wird die Prüfziffer 0 genommen)
 * Beispiel:
 * MaLo-ID: 4 1 3 7 3 5 5 9 2 4 Prüfziffer
 * a) 4 + 3 + 3 + 5 + 2 = 17
 * b) (1 + 7 + 5 + 9 + 4) * 2 = 52
 * c) 17 + 52 = 69
 * d) 70 - 69 = 1  Prüfziffer „1“
 * MaLo-ID: 4 1 3 7 3 5 5 9 2 4 1
 * Beispiel MaLo-IDS:
 * 10156370075
 * 41373559241
 *
 * siehe https://bdew-codes.de/Content/Files/MaLo/2017-04-28-BDEW-Anwendungshilfe-MaLo-ID_Version1.0_FINAL.PDF#page=7
 */
export function marktlokationsId(value) {

  if (value === '' || value === null) {
    return {
      valid: true,
      errorMessage: '',
    };
  }

  // Überprüfe, ob der Wert dem erwarteten Format entspricht
  const isValidFormat = /^(\d{11})$/.test(value);

  if (!isValidFormat) {
    return {
      valid: false,
      errorMessage: 'Bitte überprüfen Sie die Eingabe Ihrer 11-stelligen Marktlokations-ID.',
    };
  }

  // Funktion zur Berechnung der Prüfziffer
  function berechnePruefziffer(maloId) {
    // Entferne alle Nicht-Ziffern (z.B. Leerzeichen)
    maloId = maloId.replace(/\D/g, '');

    let summeUngerade = 0; // a) Quersumme aller Ziffern auf ungerader Position
    let summeGerade = 0;   // b) Quersumme aller Ziffern auf gerader Position

    // Gehe durch jede Ziffer und berechne die Quersummen
    for (let i = 0; i < maloId.length - 1; i++) {
      let ziffer = parseInt(maloId[i], 10);

      if ((i + 1) % 2 !== 0) { // Ungerade Position (1-basierte Indexierung)
        summeUngerade += ziffer;
      } else { // Gerade Position
        summeGerade += ziffer;
      }
    }

    // Berechne die Schritte b, c und d
    summeGerade *= 2; // b) Quersumme der geraden Positionen multipliziert mit 2
    let summeGesamt = summeUngerade + summeGerade; // c) Summe aus a) und b)
    let pruefziffer = (10 - (summeGesamt % 10)) % 10; // d) Differenz zum nächsten Vielfachen von 10

    return pruefziffer;
  }


  // Berechne die erwartete Prüfziffer der gegebenen MaLo-ID
  const eingegebenePruefziffer = parseInt(value[10], 10);
  const berechnetePruefziffer = berechnePruefziffer(value);

  // Überprüfe, ob die berechnete Prüfziffer mit der eingegebenen übereinstimmt
  const isValid = eingegebenePruefziffer === berechnetePruefziffer;

  return {
    valid: isValid,
    errorMessage: isValid ? '' : 'Bitte überprüfen Sie die Eingabe Ihrer 11-stelligen Marktlokations-ID.',
  };
}
